<template>
  <div class="page">
    <top-header></top-header>
    <b-container fluid>
      <b-row class="mt-3 mb-2">
        <b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
          <h3>Pump Reports</h3>
        </b-col>
        <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
          <b-button variant="dark" pill class="mr-2" @click="downloadcsv()">Download</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-card>
        <b-form inline>
          <label for="inline-form-input-name" class="mr-sm-2">Imei ID: </label>
          <b-form-select v-model="imeino" size="sm" class="mr-3">
            <b-form-select-option value="0">--- Select State ---</b-form-select-option>
            <b-form-select-option v-for="item in devices" v-bind:key="item.id" :value="item.imei_no">{{
              item.location
            }}</b-form-select-option>
          </b-form-select>
          <label for="inline-form-input-name" class="mr-sm-2">From: </label>
          <b-form-datepicker
            v-model="datefrom"
            class="mr-sm-2"
            size="sm"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
          ></b-form-datepicker>
          <label for="inline-form-input-name" class="mr-sm-2">To: </label>
          <b-form-datepicker
            v-model="dateto"
            class="mr-sm-2"
            size="sm"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
          ></b-form-datepicker>
          <b-button pill variant="dark" size="sm" @click="loadRecords()" target="_blank" download>Submit</b-button>
        </b-form>
      </b-card>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col class="col-md-12 col-sm-12 col-xs-12">
          <div class="container-box">
            <b-row class="mt-4">
              <b-col lg="6" class="text-left">
                <span class="mr-2">Show</span>
                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                </b-form-select>
                <span class="ml-2">entries</span>
              </b-col>
              <b-col lg="4" offset-md="2"> </b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col lg="12">
                <b-table
                  show-empty
                  sticky-header
                  small
                  striped
                  outlined
                  id="my-table"
                  stacked="md"
                  :items="records"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filterIncludedFields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(status)="row">
                    <b-badge pill variant="danger" v-if="row.value == 0">PROCESSING</b-badge>
                    <b-badge pill variant="success" v-else>COMPLETE</b-badge>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button
                      pill
                      variant="primary"
                      class="mr-1"
                      :href="$root.httpurl + 'exports/' + row.item.link"
                      @click="download(row.item.id)"
                      download
                      ><b-icon icon="arrow-down" scale="1.5"></b-icon>XLS</b-button
                    >
                    <b-button
                      pill
                      variant="primary"
                      class="mr-1"
                      :href="$root.httpurl + 'exports/' + row.item.link.replace('.csv', '.pdf')"
                      @click="download(row.item.id)"
                      target="blank"
                      download
                      ><b-icon icon="arrow-down" scale="1.5"></b-icon>PDF</b-button
                    >
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row class="px-3">
              <b-col lg="6">
                <span class="mr-2 text-left"
                  >Showing {{ currentPage }} to {{ perPage > records.length ? records.length : perPage }} of
                  {{ records.length }} entries</span
                >
              </b-col>
              <b-col lg="3" offset-md="3">
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  prev-text="Prev"
                  next-text="Next"
                  first-number
                  last-number
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <transition name="fade">
      <b-row
        v-if="loading"
        class="loading"
        style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);"
        align-v="center"
        align-h="center"
      >
        <b-spinner label="Busy" variant="light"></b-spinner>
      </b-row>
    </transition>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "Devices",
  components: {
    "top-header": Header,
  },
  mounted() {
    var self = this;
    // console.log("state_perm" + self.$session.get("user_info").permissions.state_perm);
    console.log("emptyItem" + JSON.stringify(self.emptyItem));
    console.log("selectedItem" + JSON.stringify(self.selectedItem));
    Object.assign(self.selectedItem, self.emptyItem);
    console.log("After selectedItem" + JSON.stringify(self.selectedItem));
    this.initload();
  },
  data() {
    return {
      loading: false,
      modelTitle: "",
      loading_status: false,
      password: "",
      initUrl: this.$root.httpurl + "api-wms/pump-list",
      recordsUrl: this.$root.httpurl + "api-wms/pump-records",
      devices: [],
      imeino: "",
      datefrom: this.$moment().format("YYYY-MM-DD"),
      dateto: this.$moment().format("YYYY-MM-DD"),
      records: [],
      zones: [],
      fields: [
        { key: "sno", label: "S No" },
        { key: "data_stamp", label: "Data Stamp" },
        { key: "voltage_r", label: "Volt. R" },
        { key: "voltage_y", label: "Volt. Y" },
        { key: "voltage_b", label: "Volt. B" },
        { key: "amp_r", label: "Amp. R" },
        { key: "amp_y", label: "Amp. Y" },
        { key: "amp_b", label: "Amp. B" },
        { key: "kwh", label: "KWH" },
        { key: "sl_voltage", label: "Supply" },
        { key: "auto_manual", label: "Auto Status" },
        { key: "device_trip", label: "Trip Status" },
        { key: "device_trip", label: "Phase Rev." },
        { key: "pump_status", label: "Pump Status" },
        { key: "phase_reverse", label: "phase_reverse" },
        { key: "insert_time", label: "Update Time" },
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: {
        state: "", //this.$session.get("user_info").permissions.state_perm,
        district: "",
        ulb: "",
      },
      emptyItem: {
        id: 0,
        type: "",
        state: "",
        district: "",
        date: "",
      },
      json_fields: {
        "S No": "sno",
        "Data Stamp": "data_stamp",
        Supply: "sl_voltage",
        "Voltage R": "voltage_r",
        "Voltage Y": "voltage_y",
        "Voltage B": "voltage_b",
        "Amp R": "amp_r",
        "Amp Y": "amp_y",
        "Amp B": "amp_b",
        "Auto Status": "auto_manual",
        "Trip Status": "device_trip",
        "Phase Reverse": "phase_reverse",
        "Pump Status": "pump_status",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  methods: {
    initload() {
      console.log("initload 001");
      var self = this;
      self.axios
        .post(self.initUrl, {
          accesskey: self.$session.get("access_key"),
          group_id: self.$session.get("group_id"),
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.devices = response.data.result.devices;

            self.$bvToast.toast(response.data.message, {
              title: "Record Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    loadRecords() {
      var self = this;
      if (self.imeino == "") {
        alert("IMEI field is blank!");
        return;
      }
      self.loading = true;
      self.axios
        .post(self.recordsUrl, {
          accesskey: self.$session.get("access_key"),
          imeino: self.imeino,
          datefrom: self.datefrom,
          dateto: self.dateto,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            var list = response.data.result.records;
            var i = 1;
            self.json_data = [];
            self.loading = false;
            list.forEach((element) => {
              element.sno = i++;

              /*element.voltage_r = (element.voltage_r/1000).toFixed(1);
                          element.voltage_y = (element.voltage_y/1000).toFixed(1);
                          element.voltage_b = (element.voltage_b/1000).toFixed(1);
  
                          element.amp_r = (element.amp_r/1000).toFixed(1);
                          element.amp_y = (element.amp_y/1000).toFixed(1);
                          element.amp_b = (element.amp_b/1000).toFixed(1);*/

              if (element.sl_voltage == "120") {
                element.sl_voltage = "ON";
              } else {
                element.sl_voltage = "OFF";
              }

              var d = element;

              if (d.inputs != null) {
                if (d.inputs.charAt(0) == 1) {
                  d.auto_manual = "AUTO";
                } else {
                  d.auto_manual = "MANUAL";
                }
              } else {
                d.auto_manual = "N/A";
              }

              if (d.inputs != null) {
                if (d.inputs.charAt(3) == 1) {
                  d.phase_reverse = "REVERSE";
                  self.phase_reverse += 1;
                } else {
                  d.phase_reverse = "N/A";
                }
              } else {
                d.phase_reverse = "N/A";
              }

              if (d.inputs != null) {
                if (d.inputs.charAt(4) == 1) {
                  d.device_trip = "TRIP";
                  self.total_device_trip += 1;
                } else {
                  d.device_trip = "N/A";
                }
              } else {
                d.device_trip = "N/A";
              }

              if (d.sl_voltage == "120") {
                d.supply = "ON";
              } else {
                d.supply = "OFF";
              }

              if (d.inputs != null) {
                if (d.inputs.charAt(2) == 1) {
                  d.pump_status = "ON";

                  self.total_device_on += 1;
                } else {
                  d.pump_status = "OFF";

                  self.total_device_off += 1;
                }
              } else {
                d.pump_status = "N/A";
              }

              self.json_data.push({
                sno: element.sno,
                data_stamp: self.$moment(element.data_stamp).format("DD-MM-YYYY hh:mm"),
                voltage_r: element.voltage_r,
                voltage_y: element.voltage_y,
                voltage_b: element.voltage_b,
                amp_r: element.amp_r,
                amp_y: element.amp_y,
                amp_b: element.amp_b,
                sl_voltage: element.sl_voltage,
                auto_manual: d.auto_manual,
                device_trip: d.device_trip,
                phase_reverse: d.phase_reverse,
                pump_status: d.pump_status,
              });
            });
            self.records = list;
            self.totalRows = self.records.length;

            self.$bvToast.toast(response.data.message, {
              title: "Record Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    downloadcsv() {
      var self = this;
      var header = new Array();
      self.fields.forEach(function(item) {
        if (!item.extra) {
          header.push(item.label);
        }
      });

      //var d = table.rows().data();
      var finalarr = new Array();
      finalarr.push(header);
      self.records.forEach(function(row) {
        var dataarr = new Array();
        self.fields.forEach(function(field) {
          if (field.key != "extra") {
            dataarr.push(row[field.key]);
          }
        });
        finalarr.push(dataarr);
      });

      let csvContent = "data:text/csv;charset=utf-8," + finalarr.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "device_report.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-color: "#FFF" !important;
  background-image: none !important;
}
.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
